module.exports = __webpack_public_path__ + "img/top-category-leisure.bd717e1f.jpg";